<template>
    <div class="section-edit">        
        <LoadingSpinner  v-if="loading" />                           
        <div  v-if="!loading">
            <h1 class="bg-principal text-white text-left pl-5">Sección</h1>
            <div class="flex flex-col">
                <!--<div class="text-left text-xs">Configuración > Sección > Editar </div>-->
                <div>
                    <div class="overflow-hidden mt-4">
                        <form action="">
                            <div class="text-left py-2">
                                <label class="text-left" for="name">ID</label>
                                <input class="w-full p-3 text-sm border-gray-200 rounded-lg focus:border-gray-200 focus:ring-0" type="text" v-model="store.id" disabled />
                            </div>
                            <div class="text-left py-2">
                                <label class="text-left" for="name">Fecha Efectiva</label>
                                <input class="w-full p-3 text-sm border-gray-200 rounded-lg focus:border-gray-200 focus:ring-0" type="date" v-model="store.effectiveDateModel" disabled  />
                            </div>
                            <div class="text-left py-2">
                                <label class="text-left" for="name">Estado</label>
                                <select class="w-full p-3 text-sm border-gray-200 rounded-lg focus:border-gray-200 focus:ring-0" v-model="store.effectiveStatus">
                                    <option value="A"> Activo </option>
                                    <option value="I"> Inactivo </option>
                                </select>
                            </div>
                            <div class="text-left py-2">
                                <label class="text-left" for="name">Descripción</label>
                                <input class="w-full p-3 text-sm border-gray-200 rounded-lg focus:border-gray-200 focus:ring-0" type="text" v-model="store.description" />
                            </div>
                            <div class="text-left py-2">
                                <label class="text-left" for="name">Coeficiente</label>
                                <input class="w-full p-3 text-sm border-gray-200 rounded-lg focus:border-gray-200 focus:ring-0" type="number" step="0.01" v-model="store.coefficient"/>
                            </div>   

                            <h1 class="bg-principal text-white text-left pl-5">Clases</h1>
                            <DataTable :headers="headers" :rows="rows" :actions="actions"/>

                            <action-bar :save_action="save" :save_label="'Guardar'" :back_label="'Volver'"/>
                        </form>
                    </div>

                    

                </div>
            </div>            
        </div> 
        <vue-basic-alert 
        :duration="300" 
        :closeIn="10000"
        ref="saveAlert" />        
    </div>
</template>
<script>
import { useSectionStore } from "@/stores/SectionStore"
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import ActionBar from '@/components/ActionBar.vue'

// eslint-disable-next-line
import VueBasicAlert from 'vue-basic-alert'
import { useRoute } from 'vue-router'
import DataTable from '@/components/DataTable.vue'

export default {
    name: 'SectionEditView',
    components:{
        LoadingSpinner,
        ActionBar,
        DataTable
    },
    data(){
        return {
            id: '',            
            effectiveDate: "1900-01-01",
            effectiveDateString: "1900-01-01",
            effectiveStatus: "A",
            description: "",
            coefficient: 0,
            classes: [],
            error: false,
            error_msg: "",
            loading: true,
            store : useSectionStore(),
            headers:[],
            rows: [],
            actions: [],
        }
    },
    setup(){
        
    },
    mounted(){ 
        this.headers = ['ID', 'Descripción', 'Estado', 'Coeficiente'];
        
        this.actions['edit'] = this.editRowAction;       

        const route = useRoute();    
        this.id = route.params.id;    
        this.effectiveDate = route.params.effectiveDate;
        this.store = useSectionStore(); 
        this.store.getSection(this.id, this.effectiveDate).then( (success) => {                       
            if(success){                 
                this.effectiveStatus = this.store.effectiveStatus;
                this.effectiveDate = this.store.effectiveDateString.slice(0,10);
                this.effectiveDateString = this.store.effectiveDateString;
                this.description = this.store.description;
                this.coefficient = this.store.coefficient;    
                this.classes = this.store.classes;              
                this.classes.forEach( el => this.pushRow(el) );
                this.loading = false;
            } else {
                this.$refs.saveAlert.showAlert(
                    'error',
                    'No existe la sección.',
                    'Error',
                    { 
                        iconSize: 35, 
                        iconType: 'solid', 
                        position: 'top right' } 
                    );
            }
         });       
    },
     methods: {      
        pushRow: function(class_obj){
            let element = class_obj;            
            let row = [];        
            row['edit_id'] = class_obj.sectionId + '/' + element.effectiveDateString + '/' + class_obj.classId;                                       
            row['data'] = [class_obj.classId,  element.description, element.effectiveStatus , element.coefficient];
            this.rows.push(row);
        },
        editRowAction: function(id){
            this.$router.push('/class/' + id);   
        },
        save: function(){            
           this.store.editSection().then((success)=>{
                if(success){
                    this.$refs.saveAlert.showAlert(
                    'success',
                    'La sección fue creada correctamente.',
                    'Éxito',
                    { 
                        iconSize: 35, 
                        iconType: 'solid', 
                        position: 'top right' } 
                    );                                         
                    
                } else {                    
                    this.$refs.saveAlert.showAlert(
                    'error',
                    'No fue posible editar la sección.',
                    'Alerta',
                    { 
                        iconSize: 35, 
                        iconType: 'solid', 
                        position: 'top right' } 
                    );
                }
            });                       
        }
    }
}
</script>

<style scoped>

</style>